import UtilityFunction from "../Util/Util";

const { buildWaLink } = UtilityFunction;

const PrivacyPolicy = () => {
    return {
        header: {
            title: "Privacy Policy",
            description: [
                `<a target="_blank" href="https://yoboycup.com" class="text-link">Yoboycup.com</a>`, 
                `This page informs you of our policies regarding the collection, use, and disclosure of Personal Information we receive from users of the Site. We use your Personal Information only for providing and improving the Site. By using the Site, you agree to the collection and use of information in accordance with this policy.`
            ]
        },
        list: [
            {
                title: "Information Collection and Use",
                description: [
                    {
                        type: "paragraph",
                        content: [
                            "While using our Site, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you. Personally identifiable information may include, but is not limited to, your name, email address, postal address, and phone number.",
                        ]
                    },
                ]
            },
            {
                title: "Log Data",
                description: [
                    {
                        type: "paragraph",
                        content: [
                            "Like many site operators, we collect information that your browser sends whenever you visit our Site. This Log Data may include information such as your computer's Internet Protocol (IP) address, browser type, browser version, the pages of our Site that you visit, the time and date of your visit, the time spent on those pages, and other statistics.",
                            // "In addition, we may use third-party services such as Google Analytics that collect, monitor, and analyze this data."
                        ]
                    },
                ]
            },
            {
                title: "Communications",
                description: [
                    {
                        type: "paragraph",
                        content: [
                            "We may use your Personal Information to contact you with upcoming sales discount, marketing or promotional materials, and other information that may be of interest to you. You may opt-out of receiving any, or all, of these communications from us by following the unsubscribe link or instructions provided in any email we send."
                        ]
                    },
                ]
            },
            {
                title: "Cookies",
                description: [
                    {
                        type: "paragraph",
                        content: [
                            "Cookies are files with a small amount of data. Cookies are sent to your browser from our web site and stored on your computer's hard drive. We use Cookies for Users who haven’t have an account in our website so they can still Buy our goods without logging in.",
                            'Like many sites, we use "cookies" to collect information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Site.'
                        ]
                    },
                ]
            },
            {
                title: "Security",
                description: [
                    {
                        type: "paragraph",
                        content: [
                            "The security of your Personal Information is important to us, but remember that no method of transmission over the Internet or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Information, we cannot guarantee its absolute security."
                        ]
                    },
                ]
            },
            {
                title: "Changes to this Privacy Policy",
                description: [
                    {
                        type: "paragraph",
                        content: [
                            "This Privacy Policy will remain in effect except with respect to any changes in its provisions in the future, which will be in effect immediately after being posted on this page.",
                            "We reserve the right to update or change our Privacy Policy at any time and you should check this Privacy Policy periodically. Your continued use of the Service after we post any modifications to the Privacy Policy on this page will constitute your acknowledgment of the modifications and your consent to abide and be bound by the modified Privacy Policy."
                        ]
                    },
                ]
            },
            {
                title: "Contact Us",
                description: [
                    {
                        type: "paragraph",
                        content: [
                            `If you have any questions about this Privacy Policy, please contact us at <a target="_blank" href="${ buildWaLink() }" class="text-link">Whatsapp</a>.`
                        ]
                    }
                ]
            },
        ]
    }
}

export default PrivacyPolicy;